import type { Config as Interface } from "../../design/types";

export class Config implements Interface {
    id: string;
    projectId: string;
    appId: string;
    storageBucket: string;
    apiKey: string;
    authDomain: string;
    messagingSenderId: string;
    measurementId: string;
    [key: string]: unknown;

    constructor(projectId: string, appId: string, storageBucket: string, apiKey: string, authDomain: string, messagingSenderId: string, measurementId: string) {
        this.id = projectId;
        this.projectId = projectId;
        this.appId = appId;
        this.storageBucket = storageBucket;
        this.apiKey = apiKey;
        this.authDomain = authDomain;
        this.messagingSenderId = messagingSenderId;
        this.measurementId = measurementId;
    }
}